import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper/modules";

import "../styles/LeadershipTeam.css";

function LeadershipTeam() {
  const teamMembers = [
    {
      name: "Upendra Koli",
      role: "Managing Director",
      image: "/assets/images/koliupendra_image.jpeg",
    },
  
    {
      name: "Dattatray Doiphode",
      role: "Sr. Production Manager",
      
      image: "/assets/images/datta photo.jpg"
    },
  ];

  return (
    <div id="page6">
      <div id="page6-heading">
        <h2>Leadership Team</h2>
        <p>Meet the minds driving our success</p>
      </div>
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={3}
        initialSlide={1}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 400,
          modifier: 1.2,
          slideShadows: false,
        }}
        navigation={true}
        modules={[EffectCoverflow, Navigation, Pagination, Autoplay]}
        className="mySwiper"
      >
        {teamMembers.map((member, index) => (
          <SwiperSlide key={index}>
            <div className="card">
              <img src={member.image} alt={member.name} className="user-image" />
              <div className="card-info">
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default LeadershipTeam;
